exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".WishListGroupModal-marginLeft-1OB9q{\r\n    margin-left: 12px;\r\n}\r\n.WishListGroupModal-paddingTop-DuXGD{\r\n    padding-top: 50px;\r\n}\r\n@media screen and (max-width: 767px) {\r\n.WishListGroupModal-mobileBtn-1hyCP{\r\n    width: 100%;\r\n}\r\n.WishListGroupModal-marginLeft-1OB9q{\r\n    margin-left: 0;\r\n    margin-top: 12px;\r\n}\r\n}", ""]);

// exports
exports.locals = {
	"marginLeft": "WishListGroupModal-marginLeft-1OB9q",
	"paddingTop": "WishListGroupModal-paddingTop-DuXGD",
	"mobileBtn": "WishListGroupModal-mobileBtn-1hyCP"
};